import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const list = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "dashboard",
      method: "get",
      authorization: true,
      config: {
        showErr: true,
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 120000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};
export const topPerformers = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "admin/top-performers",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 120000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const summary = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "admin/dashboard-summary",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 120000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export const orderStatusStats = async (args: ParamsProps) => {
  try {
    const config: ReturnType = {
      url: "admin/order-status-stats",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        store: {
          key: args?.state,
          action: "set",
        },
      },
      cacheTTL: 120000,
    };
    const response = await request(config);
    return response;
  } catch (err: any) {
    throw new Error(err);
  }
};

export default { list, topPerformers, summary, orderStatusStats };
